import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";

let galleryId;
const galleries = document.querySelectorAll('.gallery-grid');

const kkGallerySliderInit = function() {
    galleries.forEach((galleryEl) => {
        const galleryId = galleryEl.getAttribute("data-gallery-id");
        const sliderSelector = `#gallery-slider-${galleryId}`;
        const navigationSelector = `#navigation-${galleryId}`;
        const prevEl = document.querySelector(`${navigationSelector} .swiper-button-prev`);
        const nextEl = document.querySelector(`${navigationSelector} .swiper-button-next`);

        new Swiper(sliderSelector, {
            modules: [Navigation],
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 8,
            a11y: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
                disabledClass: "bg-primary/[.8]"
            },
            speed: 1100,
            freeModeMomentum: false,
            slidesPerView: 'auto',
            breakpoints: {
                0: {
                    centeredSlides: true,
                },
                1280: {
                    centeredSlides: false,
                    spaceBetween: 16,
                    loop: false,
                    rewind: true,
                },
            },
        });
    });
};

export { kkGallerySliderInit };
